import { Output, Component, Input, EventEmitter } from "@angular/core";
import { EButtonType } from "../../../data-types/button.enum";
import { iconsLibrary } from "../../../../theme/constants";

@Component({
  selector: "cowing-list-element",
  templateUrl: "./cowing-list-element.component.html",
  styleUrls: ["./cowing-list-element.component.scss"],
})
export class CowingListElementComponent {
  @Input("label") label: string;
  @Input("type") type: EButtonType = EButtonType.Primary;

  @Output("event") onClickEvent = new EventEmitter();
  iconsLibrary;
  onClick(event) {
    this.onClickEvent.emit(event);
  }

  get getChevron() {
    return `${iconsLibrary.chevronSvg}`;
  }
}
